//import * as Helper from "../../../../utils/Helper";
import ApiService from "../../../../ApiService";
import Constants from "../../../../../config/Constants";

const EditService = {
    loadScreenView: (id, successCallback, failureCallback) => {
        ApiService.post("/web/admin/dictionary/word/edit/loadscreenview", { id }, successCallback, failureCallback);
    },
    saveWord: (vo, successCallback, failureCallback) => {
        ApiService.post("/web/admin/dictionary/word/edit/save", vo, successCallback, failureCallback);
    },
    batchAddWords: (vo, successCallback, failureCallback) => {
        ApiService.post("/web/admin/dictionary/word/edit/batchadd", vo, successCallback, failureCallback);
    },
    getTaskProgress: (id, successCallback, failureCallback) => {
        ApiService.post("/web/admin/dictionary/word/edit/gettaskprogress", { id }, successCallback, failureCallback);
    },
    upload: (file, successCallback, failureCallback) => {
        let formData = new FormData();
        formData.append("fileData", file);
        formData.append("table", "Words");
        formData.append("field", "Audio");
        formData.append("uploadPath", Constants.FILE_STORAGE.TEMP_PATH + "word/audio/");
        ApiService.postFileToServer("/common/file/upload", formData, successCallback, failureCallback);
    },
    uploadImage: (file, successCallback, failureCallback) => {
        let formData = new FormData();
        formData.append("fileData", file);
        formData.append("table", "Words");
        formData.append("field", "Images");
        formData.append("uploadPath", Constants.FILE_STORAGE.TEMP_PATH + "word/images/");
        ApiService.postFileToServer("/common/file/upload", formData, successCallback, failureCallback);
    },
};

export default EditService;
